Vendd.Scripts.load(function () {

    if (isTouch())
        return;

	if ($('.pager select').length > 0)
	    $('.pager select').sSelect({ ddMaxHeight: '200px' });



	updatePagerLinks();

	function updatePagerLinks() {
		$('.pager').each(function (index, wrapper) {
			var $wrapper = $(wrapper);
			//check if main product list product folder
			if ($wrapper.data('id') !== 'products') return;
			var pageSizes = $('[data-format-url="pagesize"]', $wrapper);
			var pageJumps = $('[data-format-url="page"]', $wrapper);
			var prev = $('[data-format-url="prevpage"]', $wrapper);
			var next = $('[data-format-url="nextpage"]', $wrapper);

			var url = window.location.href,
				parts = url.split('?'),
				newUrl, newParts;

			parts[0] = parts[0].replace(/\/P\d+\//i, '');

			//prev link
			newUrl = prev.attr('href');
			if (newUrl) {
				newParts = newUrl.split('?');
				newParts[0] = newParts[0].replace(/\/P\d+\//i, '');
				if (newParts[0] !== parts[0]) {
					newParts[0] = parts[0];
					if (newParts[0][newParts[0].length - 1] !== '/') {
						newParts[0] += '/';
					}
					if (parseInt(prev.attr('data-page') || 0) > 1)
						newParts[0] = newParts[0] + 'p' + prev.attr('data-page') + '/';
					
					prev.attr('href', newParts[0] + '?' + newParts[1]);
				}
			}

			//next link
			newUrl = next.attr('href');
			if (newUrl) {
				newParts = newUrl.split('?');
				newParts[0] = newParts[0].replace(/\/P\d+\//i, '');
				if (newParts[0] !== parts[0]) {
					newParts[0] = parts[0];
					if (newParts[0][newParts[0].length - 1] !== '/') {
						newParts[0] += '/';
					}
					if (parseInt(next.attr('data-page') || 0) > 1)
						newParts[0] = newParts[0] + 'p' + next.attr('data-page') + '/';
					next.attr('href', newParts[0] + '?' + newParts[1]);
				}
			}


			//page sizes
			pageSizes.closest('.x-pager-pagesizes').hide();
			//pageSizes.each(function (index, pageSize) {
			//	var $elem = $(pageSize);
			//	newUrl = $elem.attr('data-url');
			//	newParts = newUrl.split('?');
			//	if (newParts[0] !== parts[0]) {
			//		newParts[0] = parts[0].replace(/\/P\d+\//i, '');
			//		$elem.attr('data-url', newParts[0] + '?' + newParts[1]);
			//	}
			//});

			//pages
			pageJumps.each(function (index, pageJump) {
				var $elem = $(pageJump);
				newUrl = $elem.attr('data-url');
				newParts = newUrl.split('?');
				if (newParts[0] !== parts[0]) {
					newParts[0] = parts[0].replace(/\/P\d+\//i, '');
					if (newParts[0][newParts[0].length - 1] !== '/') {
						newParts[0] += '/';
					}
					if (parseInt($elem.val() || 0) > 1)
						newParts[0] += 'p' + $elem.val() + '/';
					$elem.attr('data-url', newParts[0] + '?' + newParts[1]);
				}
			});
		});
	}

});

